// extracted by mini-css-extract-plugin
module.exports = {"modalPreview":"styles_modalPreview__2N9zM","linkDone":"styles_linkDone__3E6M0","modalPreviewImage":"styles_modalPreviewImage__3JOXS"};